module.exports = __webpack_public_path__ + "img/p26.d384478f.png";